module.exports = __webpack_public_path__ + "img/FSN.af5a6488.svg";